import {
  termsAndConditionsGoStudentLink,
  termsAndConditionsLink
} from "common/links";

import { useSelector } from "seneca-common/utils/hooks/selectors";

import useAppVariant from "features/common/hooks/useAppVariant";
import { getHelpLinkRegionCode } from "features/regions/selectors";

export default function useTermsAndConditionsLinkByVariant() {
  const appVariant = useAppVariant();

  const locale = useSelector(getHelpLinkRegionCode);

  const valuesByVariant = {
    seneca: termsAndConditionsLink(locale),
    plurall: termsAndConditionsLink(locale),
    goStudentLearning: termsAndConditionsGoStudentLink
  };

  return valuesByVariant[appVariant];
}
